import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Cookies from "js-cookie";
import { normalize } from "normalizr";
import Err from "../../../../routes/error";
import { deviceSchema, followUpSchema, releaseNoteSchema, activitySchema } from "./activity-center-schema";
import { SET_NOTIFICATIONS, ADD_NOTIFICATION, SET_REGISTERED_DEVICES, SET_REGISTERED_DEVICE, SET_CURRENT_DEVICE, EDIT_UPCOMING_ACTIVITY, SET_FIELD_KEY, REMOVE_NOTIFICATION, EDIT_NOTIFICATION, RESET_RELEASE_NOTES } from "./activity-center-mutations";
import { updateFollowUp } from "@Broker/@Modules/clients/board/store/board-api";
import { getNotifications, registerDevice, unregisterDevice, getRegisteredDevices, markAsRead, updateDeviceLastSeen } from "../api/activity-center-api";
import Amplitude from "@Shared/utils/amplitude";
import { cloneDeep, filter, pickBy } from "lodash";
export const LOAD_NOTIFICATIONS = "LOAD_NOTIFICATIONS";
export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const LOAD_REGISTERED_DEVICES = "LOAD_REGISTERED_DEVICES";
export const LOAD_CURRENT_DEVICE = "LOAD_CURRENT_DEVICE";
export const REGISTER_DEVICE = "REGISTER_DEVICE";
export const UPDATE_UPCOMING_ACTIVITY = "UPDATE_UPCOMING_ACTIVITY";
export const CLEAR_COMPLETE_ACTIVITIES = "CLEAR_COMPLETE_ACTIVITIES";
export const CLEAR_READ_STATUS = "CLEAR_READ_STATUS";
export const UPDATE_DEVICE_TOKEN = "UPDATE_DEVICE_TOKEN";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const UPDATE_DEVICE_LAST_SEEN = "UPDATE_DEVICE_LAST_SEEN";
export const CLEAR_RELEASE_NOTES = "CLEAR_RELEASE_NOTES";
const actions = {
  [LOAD_NOTIFICATIONS]: async (context, {
    filters,
    offset,
    limit
  }) => {
    try {
      const {
        activities,
        followUps,
        releaseNotes
      } = await getNotifications(filters, {
        offset,
        limit
      });
      const normalizedFollowUps = normalize(followUps, [followUpSchema]);
      const normalizedReleaseNotes = normalize(releaseNotes, [releaseNoteSchema]);
      const normalizedActivities = normalize(activities, [activitySchema]);
      context.commit(SET_NOTIFICATIONS, {
        activities: {
          allIds: normalizedActivities.result,
          byId: normalizedActivities.entities.activities || {}
        },
        followUps: {
          allIds: normalizedFollowUps.result,
          byId: normalizedFollowUps.entities.followUps || {}
        },
        releaseNotes: {
          allIds: normalizedReleaseNotes.result,
          byId: normalizedReleaseNotes.entities.releaseNotes || {}
        }
      });
      return releaseNotes.length == limit;
    } catch (e) {
      Err.handle(e, {
        customData: {
          action: LOAD_NOTIFICATIONS,
          actionParams: {
            filters
          }
        }
      });
    }
  },
  [CREATE_NOTIFICATION]: async (context, {
    type,
    notification,
    id
  }) => {
    try {
      context.commit(ADD_NOTIFICATION, {
        id,
        type,
        data: notification
      });
    } catch (e) {
      Amplitude.logHandledError(e, {
        customData: {
          action: CREATE_NOTIFICATION,
          actionParams: {
            type,
            notification,
            id
          }
        }
      });
    }
  },
  [UPDATE_UPCOMING_ACTIVITY]: async (context, {
    id,
    complete
  }) => {
    const currentFollowUp = context.state.followUps.byId[id];
    const {
      clientProfileId,
      scheduledDate,
      scheduledTime,
      description
    } = currentFollowUp;
    try {
      context.commit(EDIT_UPCOMING_ACTIVITY, {
        id,
        complete
      });
      await updateFollowUp(clientProfileId, id, {
        id,
        scheduledDate,
        scheduledTime,
        description,
        complete
      });
    } catch (e) {
      context.commit(EDIT_UPCOMING_ACTIVITY, _objectSpread(_objectSpread({}, currentFollowUp), {}, {
        id
      }));
      Err.handle(e, {
        customData: {
          action: UPDATE_UPCOMING_ACTIVITY,
          actionParams: {
            id,
            complete
          }
        }
      }, "There was an error while updating activity.");
    }
  },
  [CLEAR_RELEASE_NOTES]: async context => {
    try {
      context.commit(RESET_RELEASE_NOTES);
    } catch (e) {
      Amplitude.logHandledError(e, {
        customData: {
          action: CLEAR_RELEASE_NOTES
        }
      });
    }
  },
  [CLEAR_COMPLETE_ACTIVITIES]: async context => {
    try {
      const byId = pickBy(context.state.followUps.byId, ({
        complete
      }) => !complete);
      const allIds = _Object$keys(byId);
      context.commit(SET_NOTIFICATIONS, {
        followUps: {
          byId,
          allIds
        }
      });
    } catch (e) {
      Amplitude.logHandledError(e, {
        customData: {
          action: CLEAR_COMPLETE_ACTIVITIES
        }
      });
    }
  },
  [LOAD_REGISTERED_DEVICES]: async context => {
    try {
      const {
        notificationDevices: registeredDevices
      } = await getRegisteredDevices();
      const {
        entities,
        result
      } = normalize(registeredDevices, [deviceSchema]);
      const byId = entities.devices || {};
      const allIds = result;
      const currentDeviceId = context.state.currentDevice.deviceId;
      const currentDevice = byId[currentDeviceId];
      context.commit(SET_REGISTERED_DEVICES, {
        registeredDevices: {
          byId,
          allIds
        }
      });
      if (currentDevice) context.commit(SET_CURRENT_DEVICE, _objectSpread({}, currentDevice));
    } catch (e) {
      Amplitude.logHandledError(e, {
        customData: {
          action: LOAD_REGISTERED_DEVICES
        }
      });
    }
  },
  [REGISTER_DEVICE]: async (context, {
    token
  }) => {
    const {
      deviceId
    } = context.state.currentDevice;
    const currentDevices = cloneDeep(context.state.registeredDevices);
    try {
      context.commit(SET_REGISTERED_DEVICE, {
        deviceId
      });
      await registerDevice({
        token,
        deviceId
      });
    } catch (e) {
      context.commit(SET_REGISTERED_DEVICES, {
        registeredDevices: currentDevices
      });
      Amplitude.logHandledError(e, {
        customData: {
          action: REGISTER_DEVICE
        }
      });
    }
  },
  [UPDATE_DEVICE_TOKEN]: async (context, {
    token
  }) => {
    const {
      currentDevice
    } = context.state;
    try {
      context.commit(SET_REGISTERED_DEVICE, currentDevice);
      await unregisterDevice(currentDevice.id);
      await registerDevice(_objectSpread({
        token
      }, currentDevice));
    } catch (e) {
      Amplitude.logHandledError(e, {
        customData: {
          action: UPDATE_DEVICE_TOKEN
        }
      });
    }
  },
  [LOAD_CURRENT_DEVICE]: async context => {
    try {
      const deviceId = Cookies.get("fcmDeviceId");
      context.commit(SET_CURRENT_DEVICE, {
        deviceId
      });
    } catch (e) {
      Amplitude.logHandledError(e, {
        customData: {
          action: LOAD_CURRENT_DEVICE
        }
      });
    }
  },
  [CLEAR_READ_STATUS]: async (context, {
    type
  }) => {
    try {
      const originParse = {
        followUps: "client-profile-follow-up",
        activities: "client-activity",
        releaseNotes: "release-note"
      };
      const notifications = context.state[type];
      const unreadList = filter(notifications.byId, {
        read: false
      });
      if (!unreadList.length) return;
      const promises = _mapInstanceProperty(unreadList).call(unreadList, ({
        id,
        clientActivityId
      }) => {
        return markAsRead(originParse[type], clientActivityId || id);
      });
      context.commit(SET_FIELD_KEY, {
        type,
        key: "read",
        value: true
      });
      await _Promise.all(promises);
    } catch (e) {
      Amplitude.logHandledError(e, {
        customData: {
          action: CLEAR_READ_STATUS,
          actionParams: {
            type
          }
        }
      });
    }
  },
  [UPDATE_NOTIFICATION]: async (context, {
    type,
    notification
  }) => {
    try {
      context.commit(EDIT_NOTIFICATION, {
        type,
        data: notification
      });
    } catch (e) {
      Amplitude.logHandledError(e, {
        customData: {
          action: UPDATE_NOTIFICATION,
          actionParams: {
            type,
            notification
          }
        }
      });
    }
  },
  [UPDATE_DEVICE_LAST_SEEN]: async (context, {
    id,
    token
  }) => {
    const {
      shouldRefreshToken
    } = await updateDeviceLastSeen(id, token);
    return shouldRefreshToken;
  },
  [DELETE_NOTIFICATION]: async (context, {
    id,
    type
  }) => {
    try {
      context.commit(REMOVE_NOTIFICATION, {
        type,
        id
      });
    } catch (e) {
      Amplitude.logHandledError(e, {
        customData: {
          action: DELETE_NOTIFICATION,
          actionParams: {
            id,
            type
          }
        }
      });
    }
  }
};
export default actions;